import { render, staticRenderFns } from "./OrderIndex.vue?vue&type=template&id=06a50e86&scoped=true"
import script from "./OrderIndex.vue?vue&type=script&lang=js"
export * from "./OrderIndex.vue?vue&type=script&lang=js"
import style0 from "./OrderIndex.vue?vue&type=style&index=0&id=06a50e86&prod&lang=scss&scoped=true"
import style1 from "./OrderIndex.vue?vue&type=style&index=1&id=06a50e86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a50e86",
  null
  
)

export default component.exports